(() => {
  'use strict';
  if (window.mnzeEnsureBrushGift) return;
  const GIFT = 53755330199818, PAID_BRUSH = 51905172275466, PROTECTION = 52815593013514, THRESHOLD = 7500;
  const root = window.Shopify?.routes?.root || '/';
  const originalFetch = window.fetch.bind(window);
  const mutations = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/;
  let running = null, dirty = false, timer, changed = false;
  let declined = false, previouslyPresent = false, previouslyQualified = false;
  const managed = item => Number(item.variant_id || item.id) === GIFT;
  const linePrice = item => Number(item.final_line_price ?? item.line_price ?? 0);
  function isDiamondPainting(item) {
    return Number(item.quantity || 0) > 0 && [item.product_type, item.product_title, item.title, item.handle, item.url]
      .some(value => /diamond|diamant/i.test(String(value || '')));
  }
  function deriveState(data) {
    const cart = data.cart, items = cart.items || [];
    const brushes = items.filter(i => [GIFT, PAID_BRUSH].includes(Number(i.variant_id || i.id)));
    const excluded = typeof data.excludedCents === 'number' ? data.excludedCents : items.filter(i => [GIFT, PAID_BRUSH, PROTECTION].includes(Number(i.variant_id || i.id))).reduce((n,i) => n + linePrice(i),0);
    const subtotal = typeof cart.total_price === 'number' ? Math.max(0,cart.total_price-excluded) : 0;
    const hasDiamondPainting = items.some(isDiamondPainting);
    return {cart, brushes, gifts:brushes.filter(managed), subtotal, hasDiamondPainting, qualifies:!hasDiamondPainting && cart.currency==='EUR' && data.eligible === true && subtotal >= THRESHOLD};
  }
  async function read() {
    const r = await originalFetch(root+'?section_id=mnze-brush-gift-state', {cache:'no-store'});
    if (!r.ok) throw Error('Dein Warenkorb konnte nicht geprüft werden. Bitte versuche es erneut.');
    const el = new DOMParser().parseFromString(await r.text(),'text/html').querySelector('#MnzeBrushGiftState');
    if (!el) throw Error('Die Geschenkprüfung ist vorübergehend nicht verfügbar.');
    return deriveState(JSON.parse(el.textContent));
  }
  async function change(id,quantity) {
    const r=await originalFetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity})});
    if(!r.ok)throw Error('Dein Geschenk konnte nicht aktualisiert werden. Bitte versuche es erneut.');
    changed=true;
  }
  async function refresh() {
    if(window.cart?.getCart) window.cart.getCart();
    const page=document.querySelector('cart-items');
    if(page?.getSectionsToRender && page?.renderSections){
      const ids=page.getSectionsToRender().map(s=>s.section);
      const r=await originalFetch(root+'cart?sections='+ids.join(','),{cache:'no-store'});
      if(r.ok)page.renderSections(await r.json());
    }
  }
  async function run() {
    let attemptedAdd=false;
    for(let pass=0;pass<8;pass++) {
      dirty=false;
      const state=await read();
      if(!state.qualifies) declined=false;
      if(previouslyPresent && !state.gifts.length && previouslyQualified && state.qualifies) declined=true;
      previouslyPresent=!!state.gifts.length;previouslyQualified=state.qualifies;
      const extra=state.gifts.find((g,i)=>!state.qualifies || i>0 || state.brushes.some(b=>!managed(b)));
      if(extra){await change(extra.key,0);previouslyPresent=false;continue;}
      const gift=state.gifts[0];
      if(gift && gift.quantity!==1){await change(gift.key,1);continue;}
      if(gift && linePrice(gift)!==0){
        // An automatic gift must never silently turn into a paid item.
        await change(gift.key,0);previouslyPresent=false;declined=true;
        throw Error('Die Präzisionspinsel konnten nicht kostenlos hinzugefügt werden und wurden entfernt. Bitte prüfe deinen Warenkorb.');
      }
      if(state.qualifies && !state.brushes.length && !declined && !attemptedAdd){
        attemptedAdd=true;
        const r=await originalFetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:GIFT,quantity:1,properties:{_mnze_brush_gift:'75_after_discounts'}}]})});
        changed=true;
        if(!r.ok)throw Error('Das Geschenk konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
        continue;
      }
      if(!dirty)return;
    }
    throw Error('Dein Warenkorb wird noch aktualisiert. Bitte versuche es erneut.');
  }
  async function ensure() {
    clearTimeout(timer);
    if(running){dirty=true;await running;return ensure();}
    running=run();
    try {await running;} finally {running=null;if(changed){changed=false;await refresh();}}
  }
  window.mnzeEnsureBrushGift=ensure;
  function schedule(){dirty=true;clearTimeout(timer);timer=setTimeout(()=>ensure().catch(e=>console.warn(e.message)),350);}
  window.fetch=async function(input,options){
    const r=await originalFetch(input,options);
    const url=typeof input==='string'?input:input?.url || String(input);
    if(r.ok && mutations.test(url))schedule();
    return r;
  };
  if(window.XMLHttpRequest){
    const open=XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open=function(method,url,...args){
      this.addEventListener('load',()=>{if(this.status>=200 && this.status<300 && mutations.test(String(url)))schedule();},{once:true});
      return open.call(this,method,url,...args);
    };
  }
  window.addEventListener('pageshow',schedule);
  document.addEventListener('theme:cart:change',schedule);
  schedule();
})();
